import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

type Props = { API: string };
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const errOf = (e: any, d: string) => (e && e.response && e.response.data && e.response.data.detail) || d;
const btn: any = { padding: '5px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' };
const fmt = (v: any) => { if (!v) return '—'; try { return new Date(v).toLocaleString('pl-PL'); } catch (e) { return String(v); } };
const th: any = { textAlign: 'left', padding: '4px 6px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, whiteSpace: 'nowrap' };
const td: any = { padding: '4px 6px', borderBottom: '1px solid #f3f4f6', verticalAlign: 'top' };

export default function PsOrdersPanel({ API }: Props) {
  const [st, setSt] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<any>(null);
  const [tok, setTok] = useState('');
  const [tokMsg, setTokMsg] = useState<any>(null);
  const [fromId, setFromId] = useState('');
  const [fromRef, setFromRef] = useState('');
  const [basis, setBasis] = useState('');
  const load = () => { axios.get(API + '/settings/prestashop/orders', { headers: auth() }).then((r: any) => setSt(r.data)).catch(() => setSt(null)); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [API]);

  const saveTok = () => {
    if (!tok.trim()) return;
    setTokMsg({ ok: null, text: '⏳ Zapisuję i sprawdzam…' });
    axios.post(API + '/settings/prestashop/orders/module-token', { token: tok.trim() }, { headers: auth() })
      .then((r: any) => { setSt(r.data); setTok(''); const t = r.data.test || {}; setTokMsg(t.ok ? { ok: true, text: '✓ Zapisano — moduł odpowiada (wersja ' + (t.module || '?') + ', PrestaShop ' + (t.ps || '?') + ').' } : { ok: false, text: '✕ Zapisano, ale test nie przeszedł: ' + (t.error || 'brak odpowiedzi') }); })
      .catch((e: any) => setTokMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać tokenu.') }));
  };
  const delTok = () => {
    if (!window.confirm('Usunąć token modułu? Kody paczkomatów i punktów DPD przestaną być pobierane.')) return;
    axios.delete(API + '/settings/prestashop/orders/module-token', { headers: auth() }).then((r: any) => { setSt(r.data); setTokMsg({ ok: true, text: '✓ Token usunięty.' }); })
      .catch((e: any) => setTokMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się usunąć.') }));
  };
  const preview = () => {
    setBusy(true); setMsg({ ok: null, text: '⏳ Pobieram podgląd ze sklepu (nic nie jest zapisywane)…' });
    axios.post(API + '/settings/prestashop/orders/preview', {}, { headers: auth() })
      .then((r: any) => { setSt(r.data); setMsg({ ok: true, text: '✓ Podgląd gotowy — żadne zamówienie nie zostało dodane.' }); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się pobrać podglądu.') }))
      .finally(() => setBusy(false));
  };
  const suggest = () => {
    setBusy(true);
    axios.get(API + '/settings/prestashop/orders/suggest', { headers: auth() })
      .then((r: any) => { setFromId(String(r.data.from_id || '')); setFromRef(r.data.from_ref || ''); setBasis(r.data.basis || ''); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się ustalić numeru.') }))
      .finally(() => setBusy(false));
  };
  const setLive = (live: boolean) => {
    const n = parseInt(fromId, 10);
    if (live) {
      if (!n || n < 1) { setMsg({ ok: false, text: '✕ Wybierz zamówienie, od którego pobierać („od tego” w podglądzie albo „Zaproponuj”).' }); return; }
      if (!window.confirm('Włączyć pobieranie zamówień ze sklepu PrestaShop?\n\nCo 10 minut zamówienia od ' + (fromRef || 'wybranego') + ' (i nowsze) będą dodawane do modułu Zamówienia (status Nowe).')) return;
    }
    axios.post(API + '/settings/prestashop/orders/live', { live: live, from_id: live ? n : null, from_ref: live ? fromRef : null }, { headers: auth() })
      .then((r: any) => { setSt(r.data); setMsg({ ok: true, text: live ? '✓ Pobieranie włączone od ' + (fromRef || 'wybranego zamówienia') + '.' : '✓ Pobieranie wyłączone.' }); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zmienić.') }));
  };
  const run = () => {
    setBusy(true); setMsg({ ok: null, text: '⏳ Pobieranie zamówień ze sklepu…' });
    axios.post(API + '/settings/prestashop/orders/run', {}, { headers: auth() })
      .then((r: any) => { setSt(r.data); const i = r.data.state || {}; setMsg({ ok: !i.error, text: i.error ? '✕ ' + i.error : '✓ Gotowe — nowych zamówień: ' + (i.new || 0) + (i.status_changes ? ', zmian statusu: ' + i.status_changes : '') }); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się pobrać zamówień.') }))
      .finally(() => setBusy(false));
  };

  if (!st || !st.connected) return null;
  const i = st.state || {};
  const pv = st.preview || {};
  const rows: any[] = pv.orders || [];
  const msgEl = (m: any) => m ? <span style={{ fontSize: 12, fontWeight: 600, color: m.ok === true ? '#15803d' : (m.ok === false ? '#b91c1c' : '#6b7280') }}>{m.text}</span> : null;
  return (
    <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid #e5e7eb', fontSize: 13 }}>
      <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8 }}>Zamówienia ze sklepu</div>

      <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 12px', marginBottom: 10 }}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>Moduł OPENkontakt w PrestaShop (kody paczkomatów InPost i punktów DPD)</div>
        {st.module_token ? (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ color: '#15803d' }}>✓ Token zapisany</span>
            <button onClick={delTok} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Usuń token</button>
            {msgEl(tokMsg)}
          </div>
        ) : (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <input type="password" value={tok} onChange={e => setTok(e.target.value)} placeholder="Token z konfiguracji modułu OPENkontakt"
              style={{ flex: '1 1 260px', padding: '5px 8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 12 }} />
            <button onClick={saveTok} disabled={!tok.trim()} style={{ ...btn, opacity: tok.trim() ? 1 : 0.5 }}>Zapisz i sprawdź</button>
            {msgEl(tokMsg)}
          </div>
        )}
      </div>

      {st.live ? (
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '8px 12px', marginBottom: 10 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Pobieranie: WŁĄCZONE — co 10 minut, zamówienia od {st.from_ref || 'wybranego zamówienia'}</div>
          {(i.added || []).length > 0 ? <div style={{ fontSize: 12, color: '#374151', marginBottom: 4 }}>Ostatnio dodane: {(i.added || []).map((a: any) => a.reference + ' → ' + a.order_number).join(', ')}</div> : null}
          <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 6 }}>
            Ostatni przebieg: {fmt(i.at)}{i.error ? <span style={{ color: '#b91c1c' }}> · błąd: {String(i.error)}</span> : <span> · nowych: {i.new || 0} · pominiętych: {i.skipped || 0} · zmian statusu: {i.status_changes || 0}{i.errors ? ' · błędów: ' + i.errors : ''}</span>}
          </div>
          {(i.warnings || []).map((w: string, k: number) => <div key={k} style={{ fontSize: 12, color: '#b45309' }}>⚠ {w}</div>)}
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 }}>
            <button onClick={run} disabled={busy} style={{ ...btn, opacity: busy ? 0.5 : 1 }}>↻ Pobierz teraz</button>
            <button onClick={() => setLive(false)} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Wyłącz pobieranie</button>
          </div>
        </div>
      ) : (
        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '8px 12px', marginBottom: 10 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Pobieranie: WYŁĄCZONE — żadne zamówienie nie jest dodawane</div>
          <div style={{ fontSize: 12, color: '#374151', marginBottom: 6 }}>Sprawdź podgląd ostatnich zamówień sklepu. Gdy wszystko się zgadza, wybierz zamówienie, od którego pobierać („od tego” w tabeli albo „Zaproponuj”), i włącz.</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <button onClick={preview} disabled={busy} style={{ ...btn, opacity: busy ? 0.5 : 1 }}>👁 Podgląd (nic nie zapisuje)</button>
            <span style={{ fontSize: 12, color: '#6b7280' }}>od zamówienia: <b style={{ color: '#111827' }}>{fromRef || '—'}</b></span>
            <button onClick={suggest} disabled={busy} style={btn}>Zaproponuj</button>
            <button onClick={() => setLive(true)} style={{ ...btn, borderColor: '#16a34a', color: '#15803d', fontWeight: 600 }}>Włącz pobieranie</button>
          </div>
          {basis ? <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Propozycja: {basis}</div> : null}
        </div>
      )}
      {msg ? <div style={{ marginBottom: 8 }}>{msgEl(msg)}</div> : null}

      {rows.length > 0 && (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 10px' }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Podgląd z {fmt(pv.at)} — {rows.length} ostatnich zamówień sklepu (nic nie zostało dodane)</div>
          {(pv.warnings || []).map((w: string, k: number) => <div key={k} style={{ fontSize: 12, color: '#b45309' }}>⚠ {w}</div>)}
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', fontSize: 11, width: '100%', marginTop: 4 }}>
              <thead><tr>
                <th style={th}>Nr zamówienia</th><th style={th}>Data</th><th style={th}>Klient</th><th style={th}>Kwota</th><th style={th}>Płatność</th>
                <th style={th}>Dostawa</th><th style={th}>Faktura</th><th style={th}>Produkty</th><th style={th}>Wiadomość</th><th style={th}>Uwagi</th>
              </tr></thead>
              <tbody>
                {rows.map((r: any) => (
                  <tr key={r.ps_id} style={{ background: r.exists || r.skipped ? '#f9fafb' : '#fff', color: r.exists || r.skipped ? '#9ca3af' : '#111827' }}>
                    {r.error ? <><td style={td}>{r.ps_id}</td><td style={{ ...td, color: '#b91c1c' }} colSpan={9}>Błąd: {r.error}</td></> : <>
                      <td style={td}><b>{r.reference || r.ps_id}</b>{!st.live ? <div><button onClick={() => { setFromId(String(r.ps_id)); setFromRef(r.reference || String(r.ps_id)); setBasis(''); }} style={{ ...btn, padding: '1px 6px', fontSize: 10, marginTop: 2, background: fromId === String(r.ps_id) ? '#dcfce7' : '#fff' }}>od tego</button></div> : null}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{r.date}</td>
                      <td style={td}>{r.buyer}<div style={{ color: '#9ca3af' }}>{r.country}{r.lang ? ' · język ' + r.lang : ''}{r.email ? '' : ' · brak e-maila'}</div></td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{r.total != null ? Number(r.total).toFixed(2) : ''} {r.currency}</td>
                      <td style={td}>{r.payment}<div style={{ color: r.cod ? '#b45309' : (r.paid ? '#15803d' : '#b91c1c') }}>{r.cod ? 'pobranie' : (r.paid ? 'opłacone' : 'nieopłacone')}</div><div style={{ color: '#9ca3af' }}>{r.state}</div></td>
                      <td style={td}>{r.carrier}{r.pickup ? <div style={{ fontWeight: 600 }}>punkt: {r.pickup}</div> : null}</td>
                      <td style={td}>{r.invoice ? ('tak' + (r.vat ? ' · ' + r.vat : '')) : 'nie'}</td>
                      <td style={{ ...td, minWidth: 180 }}>{r.items}</td>
                      <td style={{ ...td, minWidth: 120 }}>{r.message || ''}</td>
                      <td style={td}>
                        {r.exists ? <div>już jest: {r.exists}</div> : null}
                        {r.skipped ? <div>pominięte ({r.skipped})</div> : null}
                        {(r.warnings || []).map((w: string, k: number) => <div key={k} style={{ color: '#b45309' }}>⚠ {w}</div>)}
                      </td>
                    </>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
